import { DevicePlatform, EPlatformType } from "../consts/platform";

import { isAndroid, isMobile, isTablet } from "react-device-detect";

export const getDevicePlatform = () => {
    if (isMobile) return DevicePlatform.MOBILE;
    if (isTablet) return DevicePlatform.TABLET;
    return DevicePlatform.DESKTOP;
}